// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".b-api-doc__title[data-v-639cad8c]{font-size:16px;line-height:30px}", "",{"version":3,"sources":["webpack://./resources/js/Layouts/ApiDocLayout.vue"],"names":[],"mappings":"AAGI,mCACE,cAAA,CACA,gBAFN","sourcesContent":["\n\n  .b-api-doc {\n    &__title {\n      font-size: 16px;\n      line-height: 30px;\n    }\n  }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
